module.exports = __webpack_public_path__ + "media/frontend/components/library/images/logo-short-inverse-71ea53f0bc3854f357eec4e26a4963e6.png";